import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
export var DateSharedCssClassName = {
    DATE_WRAPPER: "date-lozenger-container",
};
export var dateSharedStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .", " {\n    display: inline-block;\n  }\n"], ["\n  .", " {\n    display: inline-block;\n  }\n"])), DateSharedCssClassName.DATE_WRAPPER);
var templateObject_1;
//# sourceMappingURL=date.js.map